
import type { ClientName } from "./types";
import { getResolvedClientKey, getClientTheme } from "./themes";
export {
  CLIENTS,
  getClientKey,
  getResolvedClientKey,
  getClientTheme,
  getClientPalette,
  getClientFavicon,
} from "./themes";
export { getClient, isFieldVisible, CLIENTS_CONFIG } from "./fieldConfig";
export type { ClientName, ClientTheme } from "./types";

const DEFAULT_CLIENT_NAME: ClientName = "cadent";

const CLIENT_NAME_FROM_KEY: Record<string, ClientName> = {
  CADENT: "cadent",
  BROADHAM_GREEN: "broadham-green",
};

export const getClientName = (): string => {
  return String(import.meta.env.VITE_APP_BRAND ?? DEFAULT_CLIENT_NAME);
};

export const getResolvedClientName = (): ClientName => {
  const resolvedClientKey = getResolvedClientKey();
  return CLIENT_NAME_FROM_KEY[resolvedClientKey] ?? DEFAULT_CLIENT_NAME;
};


export const resolvedClientName = getResolvedClientName();
export const activeClientConfig = getClientTheme();


export const clientTheme = activeClientConfig;
export const clientName  = resolvedClientName;

export default getClientTheme;


